module.exports = __webpack_public_path__ + "static/media/ic_snapshot_activate.716fc237.svg";